import { IconsProvider } from '@talend/design-system';

IconsProvider.displayName = 'IconsProvider';

export default IconsProvider;
